import { render } from "./major-catalog-login-dialog.vue?vue&type=template&id=70797f1c&scoped=true"
import script from "./major-catalog-login-dialog.vue?vue&type=script&lang=js"
export * from "./major-catalog-login-dialog.vue?vue&type=script&lang=js"

import "./major-catalog-login-dialog.vue?vue&type=style&index=0&id=70797f1c&scoped=true&lang=css"
import "./major-catalog-login-dialog.vue?vue&type=style&index=1&id=70797f1c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70797f1c"]])

export default __exports__